import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { useTrial } from '@/components/generals/trial-provider'

interface TrialButtonProps {
    source: string
    className?: string
    children?: ReactNode
}

export const TrialButton: FC<TrialButtonProps> = ({ source, className, children = 'Get started free' }): ReactNode => {
    const { openTrial } = useTrial()

    return (
        <button
            type='button'
            onClick={() => openTrial(source)}
            className={cn(
                'inline-flex h-12 shrink-0 cursor-pointer items-center justify-center gap-2 rounded-full bg-moss px-5 text-[16px] font-semibold text-white transition-[background-color,transform] duration-200 hover:bg-moss-deep active:scale-[0.98] focus-visible:ring-2 focus-visible:ring-moss focus-visible:ring-offset-2 focus-visible:outline-none',
                className
            )}
        >
            {children}
        </button>
    )
}
